import React, { Component } from 'react';

import { Btn } from '../shared/Btn';
import { ContactField } from './ContactField';

import '../../../css/components/contact/contact-form.scss';
export class ContactForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      message: '',
    }
  }

  updateState = (e) => {
    
    this.setState({
      [e.target.name]: e.target.value,
    })
  }


  render() {
    const {
      name,
      email,
      message,
    } = this.state;

    return (
      <div className="contact-form">
        <ContactField name="name" label="Name" onChange={ this.updateState } value={ name }/>
        <ContactField name="email" label="Email" onChange={ this.updateState } value={ email } />
        <ContactField name="message" label="Message" onChange={ this.updateState } value={ message } fieldType="textarea" />

        <Btn className="blue contact">
          SEND
        </Btn>
      </div>
    )
  }
}